var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5.5H4.58333H19.25",
    stroke: "#0275B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4166 5.49998C18.4166 4.94769 17.9689 4.49998 17.4166 4.49998C16.8643 4.49998 16.4166 4.94769 16.4166 5.49998H18.4166ZM5.58325 5.49998C5.58325 4.94769 5.13554 4.49998 4.58325 4.49998C4.03097 4.49998 3.58325 4.94769 3.58325 5.49998H5.58325ZM6.33325 5.49998C6.33325 6.05226 6.78097 6.49998 7.33325 6.49998C7.88554 6.49998 8.33325 6.05226 8.33325 5.49998H6.33325ZM13.6666 5.49998C13.6666 6.05226 14.1143 6.49998 14.6666 6.49998C15.2189 6.49998 15.6666 6.05226 15.6666 5.49998H13.6666ZM16.4166 5.49998V18.3333H18.4166V5.49998H16.4166ZM16.4166 18.3333C16.4166 18.7936 16.0435 19.1666 15.5833 19.1666V21.1666C17.1481 21.1666 18.4166 19.8981 18.4166 18.3333H16.4166ZM15.5833 19.1666H6.41659V21.1666H15.5833V19.1666ZM6.41659 19.1666C5.95635 19.1666 5.58325 18.7936 5.58325 18.3333H3.58325C3.58325 19.8981 4.85178 21.1666 6.41659 21.1666V19.1666ZM5.58325 18.3333V5.49998H3.58325V18.3333H5.58325ZM8.33325 5.49998V3.66665H6.33325V5.49998H8.33325ZM8.33325 3.66665C8.33325 3.20641 8.70635 2.83331 9.16659 2.83331V0.833313C7.60178 0.833313 6.33325 2.10184 6.33325 3.66665H8.33325ZM9.16659 2.83331H12.8333V0.833313H9.16659V2.83331ZM12.8333 2.83331C13.2935 2.83331 13.6666 3.20641 13.6666 3.66665H15.6666C15.6666 2.10184 14.3981 0.833313 12.8333 0.833313V2.83331ZM13.6666 3.66665V5.49998H15.6666V3.66665H13.6666Z",
    fill: "#0275B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 10.0833V15.5833",
    stroke: "#0275B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 10.0833V15.5833",
    stroke: "#0275B6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash1);
export default __webpack_public_path__ + "static/media/trash1.d05b0efd61efe8571298d2cb11eb021c.svg";
export { ForwardRef as ReactComponent };